import {connect} from "react-redux";
import SmList from "./SmList";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../service/Lead/action";
import { selfRatingDetails, ratingSave } from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
    selfListing:state.Dealer.selfListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter,
            selfRatingDetails,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SmList);
